<template>
  <div>
    <JoinHeading
      :level="4"
      :class="styleClass.title"
    >
      {{ item.title }}
    </JoinHeading>
    <p
      v-for="paragraph in item.paragraphs"
      :key="paragraph"
      :class="styleClass.paragraph || JoinTitleParagraphStyleModule.paragraph"
    >
      {{ paragraph }}
    </p>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import JoinHeading from './JoinHeading.ts.vue';
import JoinTitleParagraphStyleModule from './JoinTitleParagraph.module.scss';

export interface StyleClass {
  title?: string;
  paragraph?: string;
}
export interface JoinTitleParagraphProps {
  title: string;
  paragraphs: string[];
}

export default Vue.extend({
  components: {
    JoinHeading,
  },
  props: {
    item: {
      type: Object as PropType<JoinTitleParagraphProps>,
      required: true,
    },
    styleClass: {
      type: Object as PropType<StyleClass>,
      default: (): StyleClass => ({}),
    },
  },
  data() {
    return {
      JoinTitleParagraphStyleModule,
    };
  },
});
</script>
